function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------
import * as merchant from '@/api/merchant';
export default {
  name: 'merUserCategoryForArea',
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    merIdChecked: {
      type: [Array, String, Number],
      default: function _default() {
        return null;
      }
    },
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      categoryId: '',
      merSelect: [],
      selectedRows: [],
      selectedIds: [],
      syncingSelection: false
    };
  },
  computed: {
    allMerchantList: function allMerchantList() {
      return this.merSelect.reduce(function (list, category) {
        var merchantList = Array.isArray(category.merchantList) ? category.merchantList : [];
        var rows = merchantList.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            categoryId: category.id,
            categoryName: category.name
          });
        });
        return list.concat(rows);
      }, []);
    },
    filteredMerchantList: function filteredMerchantList() {
      var _this = this;
      if (!this.categoryId) return this.allMerchantList;
      return this.allMerchantList.filter(function (item) {
        return item.categoryId === _this.categoryId;
      });
    },
    disabledIdSet: function disabledIdSet() {
      return new Set(this.normalizeIds(this.disabledIds));
    }
  },
  watch: {
    merIdChecked: {
      immediate: true,
      handler: function handler(n) {
        this.selectedIds = this.normalizeIds(n);
        this.updateSelectedRowsByIds();
        this.syncTableSelection();
      }
    },
    disabledIds: function disabledIds() {
      this.removeDisabledSelection();
      this.syncTableSelection();
    }
  },
  mounted: function mounted() {
    this.getMerList();
  },
  methods: {
    getMerList: function getMerList() {
      var _this2 = this;
      this.loading = true;
      merchant.merCategoryListApi().then(function (res) {
        _this2.merSelect = Array.isArray(res) ? res : [];
        _this2.updateSelectedRowsByIds();
        _this2.syncTableSelection();
      }).finally(function () {
        _this2.loading = false;
      });
    },
    normalizeIds: function normalizeIds(value) {
      if (Array.isArray(value)) return value.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      });
      if (value === '' || value === null || value === undefined) return [];
      var id = Number(value);
      return Number.isNaN(id) ? [] : [id];
    },
    getMerchantId: function getMerchantId(row) {
      return Number(row.id || row.merId || row.merchantId);
    },
    isRowDisabled: function isRowDisabled(row) {
      return this.disabledIdSet.has(this.getMerchantId(row));
    },
    isRowSelectable: function isRowSelectable(row) {
      return !this.isRowDisabled(row);
    },
    handleCategoryChange: function handleCategoryChange() {
      this.syncTableSelection();
    },
    updateSelectedRowsByIds: function updateSelectedRowsByIds() {
      var _this3 = this;
      if (!this.selectedIds.length) {
        this.selectedRows = [];
        return;
      }
      var selectedSet = new Set(this.selectedIds);
      this.selectedRows = this.allMerchantList.filter(function (item) {
        return selectedSet.has(_this3.getMerchantId(item));
      });
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      var _this4 = this;
      if (this.syncingSelection) return;
      var selectedMap = new Map(this.selectedRows.map(function (item) {
        return [_this4.getMerchantId(item), item];
      }));
      var currentIds = this.filteredMerchantList.map(function (item) {
        return _this4.getMerchantId(item);
      });
      currentIds.forEach(function (id) {
        return selectedMap.delete(id);
      });
      selection.filter(function (item) {
        return !_this4.isRowDisabled(item);
      }).forEach(function (item) {
        return selectedMap.set(_this4.getMerchantId(item), item);
      });
      this.selectedRows = Array.from(selectedMap.values()).filter(function (item) {
        return !_this4.isRowDisabled(item);
      });
      this.selectedIds = this.selectedRows.map(function (item) {
        return _this4.getMerchantId(item);
      });
      this.$emit('getMerId', this.selectedIds, this.selectedRows);
    },
    syncTableSelection: function syncTableSelection() {
      var _this5 = this;
      this.$nextTick(function () {
        if (!_this5.$refs.storeTable) return;
        _this5.syncingSelection = true;
        _this5.$refs.storeTable.clearSelection();
        var selectedSet = new Set(_this5.selectedIds);
        _this5.filteredMerchantList.forEach(function (row) {
          if (selectedSet.has(_this5.getMerchantId(row)) && !_this5.isRowDisabled(row)) {
            _this5.$refs.storeTable.toggleRowSelection(row, true);
          }
        });
        _this5.$nextTick(function () {
          _this5.syncingSelection = false;
        });
      });
    },
    removeDisabledSelection: function removeDisabledSelection() {
      var _this6 = this;
      if (!this.selectedIds.length) return;
      this.selectedRows = this.selectedRows.filter(function (item) {
        return !_this6.isRowDisabled(item);
      });
      var nextSelectedIds = this.selectedRows.map(function (item) {
        return _this6.getMerchantId(item);
      });
      if (nextSelectedIds.length !== this.selectedIds.length) {
        this.selectedIds = nextSelectedIds;
        this.$emit('getMerId', this.selectedIds, this.selectedRows);
      }
    },
    resetSelection: function resetSelection() {
      var _this7 = this;
      this.categoryId = '';
      this.selectedRows = [];
      this.selectedIds = [];
      this.$emit('getMerId', [], []);
      this.$nextTick(function () {
        if (_this7.$refs.storeTable) {
          _this7.syncingSelection = true;
          _this7.$refs.storeTable.clearSelection();
          _this7.$nextTick(function () {
            _this7.syncingSelection = false;
          });
        }
      });
    },
    refreshAreaMerchantData: function refreshAreaMerchantData() {
      this.getMerList();
    }
  }
};